'use client'

import { ReactNode, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import { StickyOptions } from '../useStickyOptions/useStickyOptions'

type Props = {
  stickyOptions?: StickyOptions
  children: ReactNode
}

const AdvertisementWrapper = ({ children, stickyOptions }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const breakpoints = useBreakpoint()

  const isWrapperEnabled = useFeatureSwitch('advertisement_wrapper_enabled')
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!isWrapperEnabled) {
      setIsVisible(true)

      return
    }

    if (!ref.current) return

    // Use checkVisibility() if supported; fallback for older browsers
    const shouldBeVisible =
      typeof ref.current.checkVisibility === 'function'
        ? ref.current.checkVisibility()
        : getComputedStyle(ref.current).display !== 'none'

    setIsVisible(shouldBeVisible)
  }, [isWrapperEnabled, breakpoints])

  return (
    <div
      className={classNames(!!stickyOptions && 'slot-sticky')}
      ref={ref}
      style={{ top: stickyOptions?.offset }}
    >
      {isVisible && children}
    </div>
  )
}

export default AdvertisementWrapper
